module.exports = __webpack_public_path__ + "img/folder-3.fbda213f.png";